import {view} from '@sail/ui';
import {createKeyframes} from '@sail/engine';
import {ChatBubbleNext} from './ChatBubbleNext';
import {ChatRow} from './ChatRow';

type Props = {
  position?: 'start' | 'end';
  avatar?: React.ReactNode | null | undefined;
};

const jump = createKeyframes({
  0: {opacity: 0.5},
  75: {opacity: 0.5},
  80: {opacity: 1, transform: 'translateY(-1px)'},
  90: {opacity: 1, transform: 'translateY(-1px)'},
  95: {opacity: 0.5},
  100: {opacity: 0.5},
});

export const TypingRowNext = ({position, avatar}: Props) => {
  return (
    <view.div className="typing-row" data-testid="typing-row">
      <ChatRow avatar={avatar} position={position} messageType="agent">
        <ChatBubbleNext messageType="agent">
          <view.div
            css={{
              // constraining the dimensions to 32x16px
              // the viewbox within the svg will ensure the
              // dimensions are accurate within that constraint (32x16)
              width: 32,
              height: 16,
              stack: 'y',
              align: 'center',
            }}
          >
            <svg
              width="100%"
              height="100%"
              // constrain the svg to 32x8 relative to the scaled dimensions
              viewBox="0 0 32 8"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <view.circle
                data-testid="typing-row-circle"
                cx={4}
                cy={4}
                r={4}
                css={{
                  animation: `${jump} 2000ms -1500ms ease-in-out infinite`,
                }}
              />
              <view.circle
                data-testid="typing-row-circle"
                cx={16}
                cy={4}
                r={4}
                css={{
                  animation: `${jump} 2000ms -1000ms ease-in-out infinite`,
                }}
              />
              <view.circle
                data-testid="typing-row-circle"
                cx={28}
                cy={4}
                r={4}
                css={{
                  animation: `${jump} 2000ms -500ms ease-in-out infinite`,
                }}
              />
            </svg>
          </view.div>
        </ChatBubbleNext>
      </ChatRow>
    </view.div>
  );
};
